const AudioFallbackVideoStates = {
  ACTIVE_VIDEO: 0,
  ACTIVE_VIDEO_WITH_WARNING: 1,
  SUSPENDED_VIDEO: 2,
};

export default AudioFallbackVideoStates;
